import React from "react";
import { Box, Typography } from "@mui/material";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: "auto",
        bgcolor: "#fff",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Copyright &copy; {currentYear} NKE Neues Kranzler Eck Berlin Immobilien GmbH &amp; Co. KG
      </Typography>
    </Box>
  );
}
